import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Helmet } from 'react-helmet/es/Helmet';
import { useSelector } from 'react-redux';
import { propArrayShape, propShape, } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import Layout from '../../../Layout';
import Breadcrumb from '../../../Layout/Breadcrumb';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import RfpPageTitle from '../../../Ui/Rfp/RfpPageTitle';
import ClientRfpHoc from '../Hoc/ClientRfpHoc';
import RfpOneArrowLink from './Parts/Head/RfpOneArrowLink';
import InterviewTopContent from './Parts/Interview/Top/InterviewTopContent';
import InterviewTopDisabledContent from './Parts/Interview/Top/InterviewTopDisabledContent';
import RfpContentSubMenu from './Parts/SubMenu/RfpContentSubMenu';
import RfpOneSkeleton from './RfpOneSkeleton';
import { rfpOneUseCase } from './UseCase/RfpOneUseCase';
const RfpOneQuestion = (props) => {
    const { offers, rfp } = props;
    const { name } = rfp;
    const auth = useSelector((state) => state.auth);
    const profile = useSelector((state) => state.profile);
    const pans = useMemo(() => [
        {
            link: '/mypage/project',
            text: 'マイページ',
        },
        {
            text: name,
        },
    ], [name]);
    const { isCanUpdateMember, isMemberAdmin, members } = rfpOneUseCase.useMemberInfo(rfp, profile, auth);
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main rfp_common_container rfp_client_one_container is_interview' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${name} 面談先を決める｜PROFFIT` }) }), _jsx(Breadcrumb, { lists: pans }), _jsx(RfpPageTitle, { text: name }), _jsx("div", Object.assign({ className: 'rfp_container' }, { children: _jsxs("div", Object.assign({ className: 'rfp_content' }, { children: [_jsxs("div", Object.assign({ className: 'rfp_content_main' }, { children: [_jsx(RfpOneArrowLink, { activeIndex: 2, offers: offers, rfp: rfp }), offers.length > 0 ? (_jsx(InterviewTopContent, { rfp: rfp })) : (_jsx(InterviewTopDisabledContent, { rfp: rfp }))] })), _jsx(RfpContentSubMenu, { isCanUpdateMember: isCanUpdateMember, isMemberAdmin: isMemberAdmin, members: members, rfp: rfp })] })) }))] })));
};
RfpOneQuestion.propTypes = {
    offers: propArrayShape().isRequired,
    rfp: propShape().isRequired,
};
const enhance = compose(AuthenticationHoc({
    isCanUseProffit: true,
    isPreClient: false,
    isPreview: true,
}), ClientRfpHoc({
    redirectCallback: ({ offers, rfp }) => {
        const isEnable = rfp.is_call_end || offers.length > 0;
        return !isEnable && `/project/client/${rfp.id}/offer`;
    },
}, RfpOneSkeleton));
export default enhance(RfpOneQuestion);
